<!--
  # RxSubject : 화면 타이틀 영역 공통 콤포넌트

  ## PROPS
  *** icon : 제목 아이콘
  *** title : 제목
  *** showBackButton : 뒤로가기 버튼 표시

  ## SLOTS
  *** prepend : 제목 및 아이콘 영역 대체
  *** append-title: 제목 뒤에 append
  *** append: 오른쪽 영역 대체
-->
<template>
  <div>
    <rx-bread-crumbs v-if="useBreadCrumbs"></rx-bread-crumbs>
    <v-toolbar dense flat short v-bind="$attrs" v-on="$listeners" >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
      <slot name="prepend">
      </slot>
      <rx-btn v-if="showBackButton" class="mr-2"
        outlined fab tile x-small color="grey lighten-1"  @click="goPrev"
      >
        <v-icon>$vuetify.icons.btn_prev_page</v-icon>
      </rx-btn> 
      <v-icon class="titleClass" size="32">{{ icon }}</v-icon>
      <v-toolbar-title 
          :class="titleClass"
      >
      {{ title }}
      </v-toolbar-title>
      <slot name="append-title"></slot>
      <v-spacer></v-spacer>
      <slot name="append" />
    </v-toolbar>
    <v-divider v-show="subjectType === 'page' "></v-divider>
  </div>
</template>

<script>
export default {
    props: {
      title: String,
      icon: String,
      subjectType: {
        type: String,
        default: ""
      },
      showBackButton: {
        type: Boolean,
        default: false
      },
      useBreadCrumbs: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        subjectTypeCss: {
          page: "ml-1 text-h5 font-weight-bold grey--text text--darken-1", //메뉴 페이지 헤더
          popup: ""
        },
      }
    },
    computed: {
      titleClass() {
        const css = this.subjectTypeCss[this.subjectType];
        if(undefined !== css) {
          return css;
        }
        return this.subjectTypeCss.page;
      },
    },
    methods: {
      goPrev() {
        const currentRoute = this.$route;
        const upRouterInfo = this.$router.resolve({
          name: currentRoute.meta.parent,
        });
        this.$router.push(upRouterInfo.route.path);
      }
    }
};
</script>

<style type="scss" scope>
.v-application ul  {
  padding-left: 0px;
} 
.v-breadcrumbs {
  padding:2px 0px
}
</style>